import { Button, ButtonProps } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { cn } from "@/lib/utils"
import React from "react"

interface TableActionsMenuProps {
  items: React.ReactNode
  triggerProps?: Partial<ButtonProps>
}

function TableActionsMenu(props: TableActionsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className={cn("size-10 rounded-full text-fg-secondary hover:bg-card-active")}
          variant="ghost"
          size="icon"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          {...props.triggerProps}
        >
          <IconMageDotsHorizontal className="size-6" />
        </Button>
      </DropdownMenuTrigger>
      {/* <DropdownMenuContent className="w-95 p-0"> */}
      <DropdownMenuContent>{props.items}</DropdownMenuContent>
    </DropdownMenu>
    // <Menu shadow="lg">
    //   <Menu.Target>
    //     <ActionIcon
    //       onClick={(e) => {
    //         e.preventDefault()
    //         e.stopPropagation()
    //       }}
    //       color="dark"
    //       variant={"subtle"}
    //       size={"lg"}
    //       type="button"
    //       {...props.triggerProps}
    //     >
    //       <IconMageDotsHorizontal className="size-6" />
    //     </ActionIcon>
    //   </Menu.Target>

    //   <Menu.Dropdown
    //     className={"min-w-[150px] border-none"}
    //     onClick={(e) => {
    //       e.preventDefault()
    //       e.stopPropagation()
    //     }}
    //   >
    //     {props.items}
    //   </Menu.Dropdown>
    // </Menu>
  )
}

export default TableActionsMenu
